module.exports = __webpack_public_path__ + "static/josh.7f3f8b6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/quote_assets/josh.png
// module id = 1110
// module chunks = 35783957827783